const initialState = {
	contactsHistoryLogs: null,
	loadNextContactsHistory: false
};

const contactsGroupItemReducer = ( state = initialState, action ) => {
	switch (action.type){
		case "FETCH_CONTACTS_HISTORY_LOGS":
			state = {
				...state,
				contactsHistoryLogs: action.payload
			};
			break;
		case "FETCH_NEXT_CONTACTS_HISTORY_LOGS":
			state = {
				...state,
				contactsHistoryLogs: {
					...state.contactsHistoryLogs,
					logs: [
						...state.contactsHistoryLogs.logs,
						...action.payload.logs
					]
				}
			};
			break;
		case "LOAD_NEXT_CONTACTS_HISTORY":
			state = {
				...state,
				loadNextContactsHistory: action.payload
			};
			break;
		default :
			break;
	}
	return state;
};

export default contactsGroupItemReducer;
